
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/practice-areas/collaborative-divorce",
      function () {
        return require("private-next-pages/practice-areas/collaborative-divorce/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/practice-areas/collaborative-divorce"])
      });
    }
  